/**
 * followUpPermissions.ts — Issue #333.
 *
 * Follow-up / outcome incident permission constants and menu helpers.
 * Mirrors backend @RequirePermission('follow_up', ...) and
 * @RequirePermission('outcome_incident', ...) decorators.
 */
import { hasPermission, hasAnyPermission } from './crmPermissions';

export { hasPermission, hasAnyPermission };

export const FOLLOW_UP_PERMISSIONS = {
  READ: 'follow_up:read',
  CREATE: 'follow_up:create',
  UPDATE: 'follow_up:update',
  REVIEW: 'follow_up:review',
  PUBLISH: 'follow_up:publish',
} as const;

export const OUTCOME_INCIDENT_PERMISSIONS = {
  READ: 'outcome_incident:read',
  CREATE: 'outcome_incident:create',
  UPDATE: 'outcome_incident:update',
  CLOSE: 'outcome_incident:close',
} as const;

export type FollowUpPermission =
  (typeof FOLLOW_UP_PERMISSIONS)[keyof typeof FOLLOW_UP_PERMISSIONS];
export type OutcomeIncidentPermission =
  (typeof OUTCOME_INCIDENT_PERMISSIONS)[keyof typeof OUTCOME_INCIDENT_PERMISSIONS];

export function canSeeFollowUpMenu(granted: readonly string[]): boolean {
  return hasAnyPermission(granted, [
    FOLLOW_UP_PERMISSIONS.READ,
    OUTCOME_INCIDENT_PERMISSIONS.READ,
  ]);
}

export function canSeeFollowUpPlansMenu(granted: readonly string[]): boolean {
  return hasPermission(granted, FOLLOW_UP_PERMISSIONS.READ);
}

export function canSeeOutcomeIncidentsMenu(
  granted: readonly string[],
): boolean {
  return hasPermission(granted, OUTCOME_INCIDENT_PERMISSIONS.READ);
}

export function canSeeFollowUpReportsMenu(
  granted: readonly string[],
): boolean {
  return hasPermission(granted, FOLLOW_UP_PERMISSIONS.READ);
}
